export const API_URL = 'https://pokeapi.co/api/v2';
